
import {Modal,Button} from 'react-bootstrap'
import React, { useEffect, useState } from 'react'
type MyProps = {
    // using `interface` is also ok
    title: string;
    message: string;
    btnOkText:string
    size:"sm"|"lg",
    close:any
  };
  type MyState = {
    showModal: boolean;
    };
class AlertDialog extends React.Component<MyProps,MyState>{
    state : MyState ={
      showModal:true
    }
    componentDidMount(){
      console.log("inside alertDialog")
    }
    dismiss () {
        this.setState({showModal:false})
        this.props.close(false)
      }
    accept = () => {
      this.setState({showModal:false})
      this.props.close(true)
    }
    createMarkup(htmlText) {
      return {__html: htmlText};
    }
    stripHtml(html: string) {
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || '';
    }
    handleShow = () =>{
      this.setState({showModal:false})
    }

    render(){
      return (
        <Modal
          show={this.state.showModal}
          onHide={() => this.dismiss()}
          size={this.props.size}
          role="alertdialog"
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-body"
        >
            <Modal.Header closeButton>
                <Modal.Title id="alert-dialog-title">{this.props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body
              id="alert-dialog-body"
              dangerouslySetInnerHTML={this.createMarkup(this.props.message)}
              aria-label={this.stripHtml(this.props.message)}
            ></Modal.Body>
            <Modal.Footer>
                <Button variant="primary" className="btn btn-primary" onClick={() => this.accept()}>
                    {this.props.btnOkText}
                </Button>
            </Modal.Footer>
        </Modal>
  );
    }
  }

  export {AlertDialog}
